import { connect } from "react-redux";
import CallFlowsComponent from "../../Components/CallFlows/CallFlowsComponent";
import { setCallFlows } from "../../Redux/Actions/CallFlowActions";
const mapStateToProps = (state) => ({
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    st_CallFlows: state.reducer.CALL_FLOWS,
    SCOPES: state.reducer.SCOPES_NAMES,
     WORKFLOWS: state.reducer.WORKFLOWS,
});
const mapDispatchToProps = (dispatch) => ({
    setCallFlows: (CALL_FLOWS) => dispatch(setCallFlows(CALL_FLOWS)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(CallFlowsComponent);